import React from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { ResponsiveHeroImage, StoryElement } from "@quintype/components";
import { StoryHeaderCard } from "../story-page-components/story-header-card.js";
import { StoryTags } from "../story-page-components/story-tags.js";
import { RelatedStories } from "../story-page-components/related-stories.js";
import { StoryPageCard } from "../story-page-components/story-page-card.js";
import { DfpAd } from "../dfp-ad";
import { MetypeCommentingWidget } from "@metype/components";
import { addTargetBlankToExtLinks } from "../../../utils/add-target-blank-to-extlinks";

function BlankStoryTemplate(props) {
  const publisherName = get(props, ['config', 'publisher-name']);
  const metypeConfig = get(props, ['config', 'theme-attributes', 'metype-config'], {});
  const cdnImage = get(props, ['config', 'cdn-image'], '');

  const {story: {cards = []} = {} }  = props;
  const firstVideo = cards.reduce((acc, currEle) => {acc = acc.concat(currEle['story-elements']); return acc;}, [])
    .find(({type, subtype}) => (type === 'youtube-video') ||  (type === 'jsembed' && subtype === 'dailymotion-video')) || {};
  const HeaderVideo = ({ story }) => {
    return (
      <div className="header-video">
        <StoryElement element={firstVideo} key={firstVideo.id} story={props.story}></StoryElement>
      </div>
    );
  };
  
  const StoryCards = props.story.cards.map((card, index) => {
    const {id: firstVideoId = -1} = firstVideo;
    if(index === 0) {
      return <div key={card.id} className="blank-story__card--with-ad">
        <StoryPageCard firstVideoElementID={firstVideoId} key={card.id} card={card} story={props.story} cdn={cdnImage}/>
        <div className="app-ad app-ad--story-horizontal">
          <DfpAd adtype="Story-Middle-Ad"/>
        </div>
      </div>
    } else {
        return <StoryPageCard firstVideoElementID={firstVideoId} key={card.id} card={card} story={props.story} cdn={cdnImage}/>
    }
  });
  
  return <article className="blank-story video-story">
      <div className="blank-story--wrapper">
        <HeaderVideo story={props.story} />
        <div className={`video-story--content ${get(props.config, ['theme-attributes', 'language_direction']) === 'right' ? 'ltr-text' : ''}`}>
          <StoryHeaderCard story={props.story} config={props.config}/>
          {StoryCards}
          <StoryTags tags={props.story.tags} config={props.config}/>
          <div className="blank-story__aside">
            <div className="app-ad app-ad--story-mrec">
              <DfpAd adtype="Story-Mrec"/>
            </div>
          </div>
        </div>
        { !props.preview && <div>
            <div className="app-ad app-ad--story-horizontal">
              <DfpAd adtype="Story-Bottom-Ad"/>
            </div>
            <div className="blank-story--metype-widget">
              { !isEmpty(metypeConfig) && <MetypeCommentingWidget
                host={metypeConfig.host}
                accountId={parseInt(metypeConfig.accountId)}
                pageURL={generateHostUrl(props.story)}
                primaryColor={metypeConfig.primaryColor}/>}
            </div>
          </div>
        }
      </div>
    </article>
}



function generateHostUrl(story = {}){
  if(global.location){
    return `${global.location.origin}/${story.slug}`;
  }
}


class VideoStory extends React.Component {
  componentDidMount() {
    addTargetBlankToExtLinks(this.storyWrapperElement);
  }
  render() {
    return <div className="story-grid" ref={(el) => this.storyWrapperElement = el}>
      <BlankStoryTemplate {...this.props}></BlankStoryTemplate>
    </div>
  }
}

export { VideoStory };
